import emailValidator from 'email-validator';
import validator from 'validator';

// split by word (on space character). Then for the last n words, append them with
// an non-breaking space character, and join the array back into a string.
export const noOrphans = (str: string, numWordsDeOrphaned: number = 2): string => {
  const words = str.split(' ');
  const lastNWords = words.splice(-numWordsDeOrphaned);
  return [...words, lastNWords.join('\u00A0')].join(' ');
};

export const getNumberSuffix = (num: number): string => {
  const th = 'th';
  const rd = 'rd';
  const nd = 'nd';
  const st = 'st';

  if (num === 11 || num === 12 || num === 13) return th;

  const lastDigit = num.toString().slice(-1);

  switch (lastDigit) {
    case '1': return st;
    case '2': return nd;
    case '3': return rd;
    default: return th;
  }
};

export const isValidEmail = (email: string): boolean => {
  return emailValidator.validate(email);
};

export const isValidUUIDV4 = (uuid: string): boolean => validator.isUUID(uuid, 4);
